export function getSampleDocImage(locale) {
  const imagePaths = {
    en: '/images/workshops/personal_preferences_sample.png',
    es_us: '/images/workshops/es_us/documentcollage.png',
    default: '/images/workshops/documentcollage.png',
  }

  const imagePath = imagePaths[locale] || imagePaths.default

  return imagePath
}
